import { RigidBody } from "@react-three/rapier";
import RoomGeometry from "./RoomGeometry";
import Decorations from "./Decorations";
import GLBObjectList from "./GlbObjectList";
import { usePlacedModelsStore, useRoomStore } from "../../store";
import { useShallow } from "zustand/shallow";
import Door from "./Door";
import RandomDoor from "./RandomDoor";

// Decorations rendered separately outside Physics for reliability
export function PlayerDecorations() {
  const scaleX = useRoomStore((s) => s.scaleX);
  const scaleZ = useRoomStore((s) => s.scaleZ);
  const decorations = useRoomStore((s) => s.decorations);

  // Force remount when decorations change by using length + first item as key
  const decorKey = `dec-${decorations.length}-${decorations[0]?.type || 'none'}`;

  return (
    <group rotation={[0, (3 * Math.PI) / 4, 0]}>
      <group scale={0.125} position={[-scaleX / 25, 0, -scaleZ / 30]}>
        <Decorations key={decorKey} />
      </group>
    </group>
  );
}

function PlayerRoom({ deferModels = false }) {
  const models = usePlacedModelsStore(useShallow((s) => s?.placedModels || []));
  const scaleX = useRoomStore((s) => s.scaleX);
  const scaleZ = useRoomStore((s) => s.scaleZ);

  return (
    <group rotation={[0, (3 * Math.PI) / 4, 0]}>
      <group scale={0.125} position={[-scaleX / 25, 0, -scaleZ / 30]}>
        {/* Decorations moved outside Physics - see PlayerDecorations */}
        {!deferModels && <GLBObjectList models={models} />}
        <Door />
        <RandomDoor />
        <RigidBody type="fixed" colliders="trimesh" ccd>
          <RoomGeometry />
        </RigidBody>
      </group>
    </group>
  );
}

export default PlayerRoom;
